// src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'; // Import routing components
import Home from './components/Home';
import About from './components/About';
import Intro from './components/Intro';
import Leaderboard from './components/LeaderboardPage'; // Import the new component
import Navbar from './components/Navbar';
import Datasets from './components/Datasets'
import Submit from './components/Submit'
import Doc from './components/Doc'
import Footer from './components/Footer';
// import './App.css'; 

// Optional: Create a component for the main page content (Home + About)
const MainPage = () => (
  <>
    {/* --- ID for potential future within-page scrolling, but navigation is now route-based --- */}
    <div id="home-section">
      <Home />
    </div>
    <div id="intro-section">
      <Intro />
    </div>
    <div id="datasets-section">
      <Datasets />
    </div>
    <div id="about-section">
      <About />
    </div>
    <div id="footer-section">
      <Footer />
    </div>
  </>
);


function App() {
  return (
    // Wrap the entire app with the Router
    <Router>
      <div className="App">
        <Navbar /> {/* Navbar is outside Routes to be persistent */}

        {/* Define the routes */}
        <Routes>
          {/* Route for the main page (Home and About) */}
          <Route path="/" element={<MainPage />} />

          {/* Route for the Leaderboard page */}
          <Route path="/leaderboard" element={<Leaderboard />} />
          <Route path="/submit-model" element={<Submit />} />         
          <Route path="/docs" element={<Doc />} />      

          {/* You could also make About its own route if desired */}
          {/* <Route path="/about" element={<About />} /> */}

          {/* Add other routes here as needed */}
        </Routes>
      </div>
    </Router>
  );
}

export default App;